/*************************************************/
/* HEADER                                        */
/*************************************************/

export function menu() {
    const menuButton = document.querySelector(".menu");
    const menu = document.querySelector(".menu-nav__wrap");
    const overlay = document.querySelector(".menu-overlay");
    const body = document.body;

    const firstFocusableElement = menu ? menu.querySelector('.menu-nav__link') : null;

    const openMenuClass = "menu-nav__wrap-open";
    const openOverlayClass = "menu-overlay--open";
    const noScrollClass = "no-scroll";

    if (!menuButton || !menu || !overlay || !firstFocusableElement) {
        console.error("Menu, button, overlay, or first focusable element not found.");
        return;
    }

    const openMenu = () => {
        menu.classList.add(openMenuClass);
        overlay.classList.add(openOverlayClass);
        body.classList.add(noScrollClass);
        menuButton.setAttribute("aria-expanded", "true");
        menu.setAttribute("aria-hidden", "false");
    };

    const closeMenu = (returnFocus = true) => {
        menu.classList.remove(openMenuClass);
        overlay.classList.remove(openOverlayClass);
        body.classList.remove(noScrollClass);

        menuButton.setAttribute("aria-expanded", "false");
        menu.setAttribute("aria-hidden", "true");

        if (returnFocus) {
            menuButton.focus();
        }
    };

    const init = () => {
        menuButton.addEventListener("click", e => {
            e.stopPropagation();
            const isMenuOpen = menu.classList.contains(openMenuClass);

            if (isMenuOpen) {
                closeMenu();
            } else {
                openMenu();

                if (e.detail === 0 || e.detail === undefined) {
                    setTimeout(() => {
                        firstFocusableElement.focus();
                    }, 10);
                }
            }
        });

        document.addEventListener("click", e => {
            const isMenuOpen = menu.classList.contains(openMenuClass);
            const isClickInsideMenu = menu.contains(e.target);
            const isClickOnButton = menuButton.contains(e.target);

            if (isMenuOpen && !isClickInsideMenu && !isClickOnButton) {
                closeMenu();
            }
        });

        document.addEventListener("keydown", e => {
            const isMenuOpen = menu.classList.contains(openMenuClass);

            if (isMenuOpen && e.key === "Escape") {
                closeMenu();
            }
        });

        menu.addEventListener('focusout', e => {
            setTimeout(() => {
                const isMenuOpen = menu.classList.contains(openMenuClass);

                if (isMenuOpen && !menu.contains(document.activeElement)) {
                    closeMenu(false);
                }
            }, 0);
        });
    }

    init();
}